import React, { useCallback } from "react";
import { FieldProps } from "react-jsonschema-form";
import { WitLabel } from "./common";
import { WEEK_DAYS } from "../../witadmin/Common/constants";
import { defineMessages, FormattedMessage } from "react-intl";
import MultiCheckBoxGroup from "../../witadmin/CRUD/Common/MultiCheckBoxGroup";

const messages = defineMessages({
  monday: {
    id: "app.periodConditions.monday",
    description: "Monday",
    defaultMessage: "Monday",
  },
  tuesday: {
    id: "app.periodConditions.tuesday",
    description: "Tuesday",
    defaultMessage: "Tuesday",
  },
  wednesday: {
    id: "app.periodConditions.wednesday",
    description: "Wednesday",
    defaultMessage: "Wednesday",
  },
  thursday: {
    id: "app.periodConditions.thursday",
    description: "Thursday",
    defaultMessage: "Thursday",
  },
  friday: {
    id: "app.periodConditions.friday",
    description: "Friday",
    defaultMessage: "Friday",
  },
  saturday: {
    id: "app.periodConditions.saturday",
    description: "Saturday",
    defaultMessage: "Saturday",
  },
  sunday: {
    id: "app.periodConditions.sunday",
    description: "Sunday",
    defaultMessage: "Sunday",
  },
});

export default function WeekDaysMultiCheckbox({ schema, formData, onChange }: FieldProps) {
  const handleOnChange = useCallback(
    ({ value }) => {
      onChange(value);
    },
    [onChange]
  );
  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      <MultiCheckBoxGroup
        className="witadmin-bs3"
        value={formData}
        field={{
          fieldName: `WeekdaysMultiCheckbox`,
          options: [
            {
              ticker: WEEK_DAYS.MONDAY,
              name: <FormattedMessage {...messages.monday} />,
            },
            {
              ticker: WEEK_DAYS.TUESDAY,
              name: <FormattedMessage {...messages.tuesday} />,
            },
            {
              ticker: WEEK_DAYS.WEDNESDAY,
              name: <FormattedMessage {...messages.wednesday} />,
            },
            {
              ticker: WEEK_DAYS.THURSDAY,
              name: <FormattedMessage {...messages.thursday} />,
            },
            {
              ticker: WEEK_DAYS.FRIDAY,
              name: <FormattedMessage {...messages.friday} />,
            },
            {
              ticker: WEEK_DAYS.SATURDAY,
              name: <FormattedMessage {...messages.saturday} />,
            },
            {
              ticker: WEEK_DAYS.SUNDAY,
              name: <FormattedMessage {...messages.sunday} />,
            },
          ],
        }}
        onChange={handleOnChange}
      />
    </>
  );
}
